import palette from '../palette';

const overrides = {
  root: {
    color: palette.icon,
    minWidth: 32,
  },
};
export default overrides;
